import { PHYSICS } from '../constants/physics.js';
import { ArenaState } from '../types/index.js';

export class ArenaManager {
  private arena: ArenaState;
  private shrinkActive: boolean = false;

  constructor(arena: ArenaState) {
    this.arena = arena;
  }

  startShrinking(): void {
    this.shrinkActive = true;
    this.arena.radius = this.arena.initialRadius;
    this.arena.brokenSegments = [];
  }

  update(_tick?: number): void {
    void _tick;
    if (!this.shrinkActive) return;

    if (this.arena.radius > this.arena.minRadius) {
      this.arena.radius -= PHYSICS.ARENA_SHRINK_RATE;
      if (this.arena.radius < this.arena.minRadius) {
        this.arena.radius = this.arena.minRadius;
      }
      this.arena.collapsePercent = 1 - (this.arena.radius - this.arena.minRadius) / (this.arena.initialRadius - this.arena.minRadius);
    }
  }

  isCollapsing(): boolean {
    return this.shrinkActive;
  }

  getRadius(): number {
    return this.arena.radius;
  }

  isInArena(x: number, y: number, playerRadius: number): boolean {
    const dist = Math.sqrt(x * x + y * y);
    return dist <= this.arena.radius - playerRadius;
  }
}